import { initializeApp } from "https://www.gstatic.com/firebasejs/11.6.1/firebase-app.js";
import { getDatabase, ref, onValue, get, set, update } from "https://www.gstatic.com/firebasejs/11.6.1/firebase-database.js";


const firebaseConfig = {
 apiKey: "AIzaSyBoUtjHEuSQE2DW6fD5mtxKvjaGqiF37lA",
 authDomain: "reels---data.firebaseapp.com",
 databaseURL: "https://reels---data-default-rtdb.firebaseio.com",
 projectId: "reels---data",
 storageBucket: "reels---data.appspot.com",
 messagingSenderId: "972871377590",
 appId: "1:972871377590:web:b48e40b9d35803c9d0bc17"
};


const app = initializeApp(firebaseConfig);
const db = getDatabase(app);


function waitForElement(selector, callback) {
 const el = document.querySelector(selector);
 if (el) {
   callback(el);
 } else {
   setTimeout(() => waitForElement(selector, callback), 100);
 }
}


document.addEventListener("DOMContentLoaded", () => {
 const cards = document.querySelectorAll('.reel-card');
 const popup = document.getElementById('reelPopup');
 const popupVideo = document.getElementById('popupVideo');
 const popupImage = document.getElementById('popupImage');
 const popupName = document.getElementById('popupName');
 const popupPrice = document.getElementById('popupPrice');
 const popupProductLink = document.getElementById('popupProductLink');
 const likeCount = document.getElementById('likeCount');
 const likeIcon = document.getElementById('likeIcon');
 const progressBar = document.getElementById('progressBar');
 const reelsSlider = document.getElementById('reelsSlider');
 const scrollPrevButton = document.getElementById('reelsScrollPrev');
 const scrollNextButton = document.getElementById('reelsScrollNext');
 const popupProductInfo = document.getElementById('popupProductInfo');


 let currentIndex = null;
 let likedReels = JSON.parse(localStorage.getItem('likedReels') || '{}');
 let viewedReels = JSON.parse(localStorage.getItem('viewedReels') || '{}');
 let viewedReelsSession = {};
 let currentProduct = { id: null, url: '', handle: '', variantId: null };


 const formatNumber = n =>
   n >= 1e6 ? (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M' :
   n >= 1e3 ? (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'k' :
   n || "0";


 const loadViews = (id) => {
   const viewsRef = ref(db, `reels/${id}`);
   onValue(viewsRef, snapshot => {
     const data = snapshot.val();
     const viewsElement = document.getElementById(`views-${id}`);
     if (viewsElement) {
       viewsElement.innerHTML = `<i class="fa-solid fa-eye"></i> ${formatNumber(data?.views)}`;
     }
   });
 };


 function updateScrollButtons() {
   if (!reelsSlider) return;
   const isAtStart = reelsSlider.scrollLeft <= 0;
   const isAtEnd = reelsSlider.scrollLeft + reelsSlider.offsetWidth >= reelsSlider.scrollWidth - 5;
   if (scrollPrevButton) {
     scrollPrevButton.disabled = isAtStart;
     scrollPrevButton.classList.toggle('reel_btn-disabled', isAtStart);
     scrollPrevButton.style.display = isAtStart && isAtEnd ? 'none' : '';
   }
   if (scrollNextButton) {
     scrollNextButton.disabled = isAtEnd;
     scrollNextButton.classList.toggle('reel_btn-disabled', isAtEnd);
     scrollNextButton.style.display = isAtStart && isAtEnd ? 'none' : '';
   }
 }


 function scrollReels(direction) {
   const cardWidth = reelsSlider?.querySelector('.reel-card')?.offsetWidth || 200;
   reelsSlider.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
   setTimeout(updateScrollButtons, 400);
 }


 scrollPrevButton?.addEventListener('click', () => scrollReels(-1));
 scrollNextButton?.addEventListener('click', () => scrollReels(1));


 const updatePopup = (card, index) => {
   const id = card.getAttribute('data-id');
   const videoEl = card.querySelector('video');
   const productImg = card.querySelector('.product-label img');
   const productTitle = card.querySelector('.product-info h3');
   const productPrice = card.querySelector('.product-info p');
   const productAnchor = card.querySelector('.product-label a');


   const videoUrl = videoEl?.src || '';
   const imgSrc = productImg?.src || '';
   const name = productTitle?.textContent || 'No product title';
   const priceHtml = productPrice?.innerHTML || '';
   const productLink = productAnchor?.href || '#';
   const handle = productLink.includes('/products/') ? productLink.split('/products/')[1] : '';


   popup.style.display = 'flex';
   document.body.style.overflow = 'hidden';


   popupVideo.src = videoUrl;
   popupImage.src = imgSrc;
   popupName.textContent = name;
   popupPrice.innerHTML = priceHtml;
   popupProductLink.href = productLink;
   popupVideo.play();


   currentIndex = index;
   currentProduct = { id, url: productLink, handle, variantId: null };


   if (name.trim() === 'No product title') {
     popupProductInfo.setAttribute('style', 'display: none !important;');
   } else {
     popupProductInfo.removeAttribute('style');
   }


   const reelRef = ref(db, `reels/${id}`);
   get(reelRef).then(snapshot => {
     let data = snapshot.val();
     if (!data) {
       set(reelRef, { views: 1, likes: 0 });
       likeCount.textContent = "0";
     } else {
       if (!viewedReels[id] && !viewedReelsSession[id]) {
         update(reelRef, { views: data.views + 1 });
         viewedReels[id] = true;
         viewedReelsSession[id] = true;
         localStorage.setItem('viewedReels', JSON.stringify(viewedReels));
       }
       likeCount.textContent = formatNumber(data.likes);
     }


     if (likedReels[id]) {
       likeIcon.classList.add('fa-solid', 'liked');
       likeIcon.classList.remove('fa-regular');
     } else {
       likeIcon.classList.remove('fa-solid', 'liked');
       likeIcon.classList.add('fa-regular');
     }
   });


   bindVideoEnd();
   updateScrollButtons();
 };


 cards.forEach((card, index) => {
   const id = card.getAttribute('data-id');
   card.addEventListener('click', () => updatePopup(card, index));
   loadViews(id);
 });


 reelsSlider?.addEventListener('scroll', () => requestAnimationFrame(updateScrollButtons));
 updateScrollButtons();


 if (progressBar && popupVideo) {
   popupVideo.addEventListener('timeupdate', () => {
     const value = (popupVideo.currentTime / popupVideo.duration) * 100;
     progressBar.value = value;
     progressBar.style.background = `linear-gradient(to right, #fff 0%, #fff ${value}%, #444 ${value}%, #444 100%)`;
   });


   progressBar.addEventListener('input', e => {
     if (popupVideo.duration) popupVideo.currentTime = (e.target.value / 100) * popupVideo.duration;
   });
 }


 window.likeReel = () => {
   if (currentIndex === null) return;
   const id = cards[currentIndex].getAttribute('data-id');
   const reelRef = ref(db, `reels/${id}`);


   get(reelRef).then(snapshot => {
     let likes = snapshot.val()?.likes || 0;
     const liked = likedReels[id];


     if (liked) {
       likes = Math.max(0, likes - 1);
       delete likedReels[id];
     } else {
       likes += 1;
       likedReels[id] = true;
     }


     likeCount.textContent = formatNumber(likes);
     update(reelRef, { likes });
     localStorage.setItem('likedReels', JSON.stringify(likedReels));


     if (likedReels[id]) {
       likeIcon.classList.add('fa-solid', 'liked');
       likeIcon.classList.remove('fa-regular');
     } else {
       likeIcon.classList.remove('fa-solid', 'liked');
       likeIcon.classList.add('fa-regular');
     }
   });
 };


 window.closePopup = () => {
   popup.style.display = 'none';
   document.body.style.overflow = '';
   popupVideo.pause();
   popupVideo.src = "";
 };


 window.toggleMute = () => {
   popupVideo.muted = !popupVideo.muted;
   const muteIcon = document.getElementById('muteIcon');
   muteIcon.classList.toggle('fa-volume-mute', popupVideo.muted);
   muteIcon.classList.toggle('fa-volume-up', !popupVideo.muted);
 };


 window.changeSlide = step => {
   const newIndex = currentIndex + step;
   if (newIndex >= 0 && newIndex < cards.length) {
     cards[newIndex].click();
   }
 };


 window.shareReel = () => {
   if (currentIndex === null) return;
   const card = cards[currentIndex];
   const shareData = {
     title: card.querySelector('h3')?.innerText || "Check this reel!",
     text: 'Watch this awesome reel!',
     url: card.querySelector('video')?.src || window.location.href
   };
   navigator.share?.(shareData).catch(console.error);
 };


 popupVideo?.addEventListener('touchstart', e => startX = e.touches[0].clientX);
 popupVideo?.addEventListener('touchend', e => { endX = e.changedTouches[0].clientX; handleSwipe(); });


 popupVideo?.addEventListener('mousedown', e => { isMouseDown = true; startX = e.clientX; popupVideo.style.cursor = 'grabbing'; });
 popupVideo?.addEventListener('mouseup', e => { if (!isMouseDown) return; endX = e.clientX; isMouseDown = false; popupVideo.style.cursor = 'grab'; handleSwipe(); });
 popupVideo?.addEventListener('mouseleave', e => { if (!isMouseDown) return; endX = e.clientX; isMouseDown = false; popupVideo.style.cursor = 'grab'; handleSwipe(); });
 popupVideo?.addEventListener('mousemove', () => { if (!isMouseDown) popupVideo.style.cursor = 'grab'; });


 let startX = 0;
 let endX = 0;
 let isMouseDown = false;


 function handleSwipe() {
   const diff = endX - startX;
   const threshold = 50;
   if (diff > threshold) changeSlide(-1);
   else if (diff < -threshold) changeSlide(1);
 }


 function handleVideoEnd() {
   const nextIndex = currentIndex + 1;
   if (nextIndex < cards.length) {
     changeSlide(1);
   } else {
     closePopup();
   }
 }


 function bindVideoEnd() {
   popupVideo.removeEventListener('ended', handleVideoEnd);
   popupVideo.addEventListener('ended', handleVideoEnd);
 }


 function adjustCardColumnsFromSettings() {
   const slider = document.getElementById('reelsSlider');
   if (!slider) return;


   const desktopCols = parseInt(slider.dataset.columnsDesktop || '5');
   const tabletCols = parseInt(slider.dataset.columnsTablet || '3');
   const mobileCols = parseInt(slider.dataset.columnsMobile || '2');
   const screenWidth = window.innerWidth;


   let columns;
   if (screenWidth < 768) {
     columns = mobileCols;
   } else if (screenWidth < 1024) {
     columns = tabletCols;
   } else {
     columns = desktopCols;
   }


   document.documentElement.style.setProperty('--reel-columns', columns);
 }


 adjustCardColumnsFromSettings();
 window.addEventListener('resize', adjustCardColumnsFromSettings);
});


document.addEventListener("DOMContentLoaded", function () {
 const video = document.getElementById("popupVideo");
 const loader = document.getElementById("videoLoader");
 loader.style.display = "block";
 video.addEventListener("waiting", () => { loader.style.display = "block"; });
 video.addEventListener("playing", () => { loader.style.display = "none"; });
 video.addEventListener("canplay", () => { loader.style.display = "none"; });
});